import React from 'react';
import {Redirect} from 'react-router-dom';

export default function InvoiceSent(){

    return(
        <Redirect to='/invoiceSuccess' />
    )
}